import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useOnce } from 'react-lib/dist/hooks-es';
import { withTranslation } from 'react-i18next';

import 'react-lib/dist/components-es.css';
import { Loading } from 'react-lib/dist/components-es';
import { TitleProvider } from './components/TitleContextProvider';
import MessagesComponent from './components/common/MessagesComponent';
import HeaderComponent from './components/navigation/HeaderComponent';
import ContentContainer from './components/navigation/ContentContainer';
import NavSidebar from './components/navigation/NavSidebar';
import useIsMobileDisplay from './hooks/useIsMobileDisplay';
import MobileHeaderComponent from './components/navigation/MobileHeader/MobileHeaderComponent';
import { initActions } from './behavior/init';
import useUser from '@behavior/init/getUserV2';

function App({ start }) {
  const { user } = useUser();
  const isMobile = useIsMobileDisplay();

  useOnce(() => {
    start();
  });

  if (user !== undefined) {
    return Object.keys(user).length !== 0 ? (
      <TitleProvider>
        <MessagesComponent />
        {isMobile ? <MobileHeaderComponent /> : <HeaderComponent />}
        <NavSidebar />
        <ContentContainer />
      </TitleProvider>
    ) : (
      <Loading isLoading />
    );
  } else {
    return <Loading isLoading />;
  }
}

App.propTypes = {
  start: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  sessionInterval: state.init.sessionInterval,
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(initActions, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(),
  withRouter
)(App);
